$(document).on('change', '#excel_file', function() {
  $('#file-import-form').submit()
});